import { Component, EventEmitter, Output, ViewEncapsulation, inject, input } from '@angular/core'
import { SmartquoteHelperService } from '../../../services/smartquote-helper.service'
import { CurrencyPipe } from '@angular/common'
import { ButtonComponent } from 'src/app/shared/components/form-elements/button/button.component'
import { SmartQuote } from 'src/app/shared/interfaces/smartquote/smart-quote.interface'

@Component({
    selector: 'sf-smartquote-totals',
    imports: [ButtonComponent, CurrencyPipe],
    templateUrl: './smartquote-totals.component.html',
    styleUrl: './smartquote-totals.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class SmartquoteTotalsComponent {
    quote = input<SmartQuote | null>()
    total = input<number | null>()

    @Output()
    onAccept = new EventEmitter()

    @Output()
    onDecline = new EventEmitter()
}
